import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Pillars from "./components/Pillars";
import StatsSection from "./components/StatsSection";
import ComplianceSection from "./components/ComplianceSection";
import DeveloperSection from "./components/DeveloperSection";
import Footer from "./components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Pillars />
      <StatsSection />
      <ComplianceSection />
      <DeveloperSection />
      <Footer />
    </div>
  );
};

// Placeholder pages for navigation
const PlaceholderPage = ({ title }) => (
  <div className="min-h-screen bg-white">
    <Header />
    <div className="container mx-auto px-4 py-20 text-center">
      <h1 className="text-4xl font-bold text-gray-900 mb-4">{title}</h1>
      <p className="text-xl text-gray-600">This page is under construction.</p>
    </div>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solutions/game-aggregation" element={<PlaceholderPage title="Game Aggregation" />} />
          <Route path="/solutions/esports-feeds" element={<PlaceholderPage title="Esports Feeds" />} />
          <Route path="/solutions/gamification" element={<PlaceholderPage title="Gamification" />} />
          <Route path="/solutions/localization" element={<PlaceholderPage title="Localization" />} />
          <Route path="/pricing" element={<PlaceholderPage title="Pricing" />} />
          <Route path="/docs" element={<PlaceholderPage title="Documentation" />} />
          <Route path="/case-studies" element={<PlaceholderPage title="Case Studies" />} />
          <Route path="/compliance" element={<PlaceholderPage title="Compliance" />} />
          <Route path="/blog" element={<PlaceholderPage title="Blog" />} />
          <Route path="/contact" element={<PlaceholderPage title="Contact" />} />
          <Route path="*" element={<PlaceholderPage title="Page Not Found" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;